import React, { useEffect } from "react";
import { Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { HubButton, HubHookFormWrapper } from "../../components";
import { useGetPasswordTokenById, usePutCreatePassword } from "../../hooks";

import ResestPasswordFullfilmentFields from "./ResestPasswordFullfilmentFields";

const ResetPasswordFullfillment = ({ token = "" }) => {
  const navigate = useNavigate();
  const { isLoading } = useGetPasswordTokenById(token);
  const {
    mutate: putCreatePasswordToken,
    isSuccess,
    data: email,
  } = usePutCreatePassword();

  useEffect(() => {
    if (isSuccess) navigate(`/signin?email=${email}`);
  }, [isSuccess]);

  const onSubmit = (formData) => {
    const payload = {
      token,
      password: formData?.password,
    };
    putCreatePasswordToken(payload);
  };

  return (
    <HubHookFormWrapper onSubmit={onSubmit}>
      <Stack width="100%" gap="25px" alignItems="center">
        <ResestPasswordFullfilmentFields isLoading={isLoading} />
        <HubButton
          variant="contained"
          size="small"
          label="Reset Password"
          sx={{ width: "100%" }}
          disabled={isLoading}
          type="submit"
        />
      </Stack>
    </HubHookFormWrapper>
  );
};

export default ResetPasswordFullfillment;
